/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import ReactDOM from "react-dom";
import Button from "@mui/material/Button";
import _ from "lodash";
import PriceInputRow from "./PriceInputRow";
import RailIconFO from "../../../icons/RailIconFO";
import TruckIconFO from "../../../icons/TruckIconFO";
import { icons } from "../../../svg";
// import ViewGuidanceIcon from "../../../svg/viewGuidanceIcon.svg?react";
import { useNitroStore } from "../../../store/Store";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";
import Debounce from "../../../utils/Debounce";
import NitroService from "../../../utils/nitro.service";
import { IFavoriteOrigin } from "../../../types/IFavoriteOrigins";
import { competitorMenuItems, kochMenuItems } from "../../../utils/constants";

const debounce = new Debounce(500);
const portalRoot = document.getElementById("portal-root");
interface OriginColumnProps {
  origin: IFavoriteOrigin;
  user: string;
  type: string;
  onRemove: (type: string, originId: string) => void;
  isMenuOpen: boolean;
  onMenuToggle: (event: React.MouseEvent) => void;
  onCloseMenu: () => void;
}

type ModeKey = "truck" | "rail";

const OriginColumn: React.FC<OriginColumnProps> = ({
  origin,
  user,
  type,
  onRemove,
  isMenuOpen,
  onMenuToggle,
  onCloseMenu,
}) => {
  const [modeData, setModeData] = useState<{
    truck: { visible: boolean; minValue: string; maxValue: string };
    rail: { visible: boolean; minValue: string; maxValue: string };
  }>({
    truck: {
      // truck is visible if there is no prices set or there is a truck max price
      visible: !!(
        (!origin.truckMaxPrice && !origin.railMaxPrice) ||
        origin.truckEnabled
      ),
      minValue: origin.truckMinPrice?.toString() || "",
      maxValue: origin.truckMaxPrice?.toString() || "",
    },
    rail: {
      visible: !!origin.railEnabled,
      minValue: origin.railMinPrice?.toString() || "",
      maxValue: origin.railMaxPrice?.toString() || "",
    },
  });

  const [hoverState, setHoverState] = useState<{
    truck: boolean;
    rail: boolean;
  }>({
    truck: false,
    rail: false,
  });

  const [isSearching, setIsSearching] = useState(false);

  const buttonRef = useRef<HTMLButtonElement>(null);
  const [menuPosition, setMenuPosition] = useState<{
    top: number;
    left: number;
  } | null>(null);
  const [
    // setShowGuidancePanel,
    setShowIndicationHistoryPanel,
    setShowAddIndicationHistoryPanel,
    setSelectedFavoriteOrigin,
    currentFilters,
    product,
    locations,
    setFetchFavoriteOrigins,
    setSelectedLocation,
    setTempPinLocation,
    setShowCompetitiveAnalysisModal,
    openInsightsPanel,
    refetchIndicationHistory,
  ] = useNitroStore((state) => [
    // state.setShowGuidancePanel,
    state.setShowIndicationHistoryPanel,
    state.setShowAddIndicationHistoryPanel,
    state.setSelectedFavoriteOrigin,
    state.currentFilters,
    state.product,
    state.locations,
    state.setFetchFavoriteOrigins,
    state.setSelectedLocation,
    state.setTempPinLocation,
    state.setShowCompetitiveAnalysisModal,
    state.openInsightsPanel,
    state.refetchIndicationHistory,
  ]);
  const [
    setDisplayFreightDetailsPanel,
    toggleOriginVisibility,
    expandedDestinationId,
    setExpandedDestination,
    triggerRefetchMultiLocation,
  ] = useNitroCAStore((state) => [
    state.setDisplayRailFreightDetailsPanel,
    state.toggleOriginVisibility,
    state.expandedDestId,
    state.setExpandedDestination,
    state.triggerRefetchMultiLocation,
  ]);
  const availableModes =
    origin.location.modesOut.map((mode) => mode.toUpperCase()) || [];
  const originKey = `${origin.competitor ? "competitor" : "koch"}-${
    origin.location.name
  }`;

  // TODO: remove this if determined to be unnecessary after testing
  // Initialize visibility based on current modeData
  // useEffect(() => {
  //   toggleOriginVisibility(originKey, "truck", modeData.truck.visible);
  //   toggleOriginVisibility(originKey, "rail", modeData.rail.visible);
  // }, []);
  const removeFavoriteOrigin = async () => {
    if (!origin) return;
    await NitroService.deleteFavoriteOrigin(
      user,
      product,
      origin.location.id,
      type !== "koch",
    );
    setFetchFavoriteOrigins(true);
  };

  useEffect(() => {
    if (
      currentFilters.city ||
      currentFilters.location ||
      currentFilters.party
    ) {
      setIsSearching(true);
    } else {
      setIsSearching(false);
    }
  }, [currentFilters]);

  useLayoutEffect(() => {
    if (isMenuOpen && buttonRef.current) {
      setSelectedFavoriteOrigin([origin]);
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  }, [isMenuOpen, origin, setSelectedFavoriteOrigin]);

  const fetchIndicationHistory = useCallback(async () => {
    refetchIndicationHistory(origin.location.id, origin.location.name);
  }, [refetchIndicationHistory, origin.location.id, origin.location.name]);

  const handleMenuAction = async (action: string) => {
    if (action === "remove") {
      onRemove(type, origin.location.id);
      removeFavoriteOrigin();
      return;
    }
    if (action === "overview") {
  
      const selectedFavoriteOrigin = _.find(locations, (location) => {
        return location.id === origin.location.id;
      });

      if (selectedFavoriteOrigin && 
          selectedFavoriteOrigin.pinType === "zipCodes") {
        return;
      }

      if (!selectedFavoriteOrigin) {
        try {
          await NitroService.getLocationDetails(origin.location.id);
        } catch (err) {
          console.error("Failed to load overview location details", err);
        }
      } else {
          setSelectedLocation(selectedFavoriteOrigin);
          setTempPinLocation({
            lat: selectedFavoriteOrigin.lat ?? 0,
            lng: selectedFavoriteOrigin.long ?? 0,
          });
      }

      setShowCompetitiveAnalysisModal(false);
      setDisplayFreightDetailsPanel(false);
      openInsightsPanel(origin.location.id, "Logistics", false);
  
      onCloseMenu();
    }
    // if (action === "guidance") {
    //   setShowGuidancePanel(true);
    // }
    if (action === "add-fob") {
      setShowAddIndicationHistoryPanel(true);
      setShowCompetitiveAnalysisModal(false);
      setShowIndicationHistoryPanel(false);
    }
    if (action === "history") {
      await fetchIndicationHistory();
      setShowIndicationHistoryPanel(true);
      setShowCompetitiveAnalysisModal(false);
      setShowAddIndicationHistoryPanel(false);
    }
    onCloseMenu();
  };

  const menuItems = type === "koch" ? kochMenuItems : competitorMenuItems;

  const dropdownMenu = isMenuOpen && menuPosition && (
    <div
      className="favorite-origin-dropdown-menu"
      style={{
        position: "fixed", // Use 'fixed' positioning for portaled items
        top: `${menuPosition.top}px`,
        left: `${menuPosition.left}px`,
      }}
      onClick={(e) => e.stopPropagation()}
      role="menu"
      tabIndex={-1}
      onKeyDown={(e) => e.stopPropagation()}
    >
      {menuItems.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => handleMenuAction(item.action)}
          className={`dropdown-menu-item ${item.className}`}
        >
          {item.icon}
          <span>{item.label}</span>
        </button>
      ))}
    </div>
  );

  const handleModeToggle = (mode: ModeKey) => {
    const newVisible = !modeData[mode].visible;

    setModeData((prev) => ({
      ...prev,
      [mode]: { ...prev[mode], visible: newVisible },
    }));
    toggleOriginVisibility(originKey, mode, newVisible);
    // flip the enabled flag and update
    const updatedOrigin = {
      ...origin,
      [`${mode}Enabled`]: !origin[`${mode}Enabled`],
    };
    debounce.call(async () => {
      await NitroService.updateFavoriteOrigin(updatedOrigin, user, product);
      setFetchFavoriteOrigins(true);
      triggerRefetchMultiLocation();
    });
  };
  const handleFobChange = (mode: ModeKey, value: string) => {
    setModeData((prevState) => ({
      ...prevState,
      [mode]: {
        ...prevState[mode],
        maxValue: value,
      },
    }));

    const priceValue = value && value.trim() !== "" ? parseFloat(value) : null;
    const updatedOrigin = {
      ...origin,
      [`${mode}MaxPrice`]: priceValue,
    };

    debounce.call(async () => {
      await NitroService.updateFavoriteOrigin(updatedOrigin, user, product);
      setFetchFavoriteOrigins(true);
      triggerRefetchMultiLocation();
      if (expandedDestinationId) {
        setExpandedDestination({ id: expandedDestinationId, name: "" });
      }
    });
  };
  const handleAltChange = (mode: ModeKey, value: string) => {
    setModeData((prevState) => ({
      ...prevState,
      [mode]: {
        ...prevState[mode],
        minValue: value,
      },
    }));
    const updatedOrigin = {
      ...origin,
      [`${mode}MinPrice`]:
        value && value.trim() !== "" ? parseFloat(value) : null,
    };
    debounce.call(async () => {
      await NitroService.updateFavoriteOrigin(updatedOrigin, user, product);
      setFetchFavoriteOrigins(true);
      triggerRefetchMultiLocation();
      if (expandedDestinationId) {
        setExpandedDestination({ id: expandedDestinationId, name: "" });
      }
    });
  };
  return (
    <div
      className="origin-column"
      style={{
        backgroundColor: isSearching ? "#f1f5f9" : undefined,
        height: isSearching ? "92%" : "100%",
      }}
    >
      <div className="origin-header">
        <span style={{ color: "#0F172A" }}>{origin.location.name}</span>
        <div id="city-drop-down" className="dropdown">
          <Button
            id="favorite-origin-action-button"
            onClick={onMenuToggle}
            ref={buttonRef}
            disableRipple
            sx={{
              minWidth: "auto",
              "&:hover": {
                backgroundColor: "#e0f2fe",
              },
            }}
          >
            <img src={icons.DownwardArrowCity} alt="CityDownArrowIcon" />
          </Button>
          {portalRoot && ReactDOM.createPortal(dropdownMenu, portalRoot)}
        </div>
      </div>

      <div
        className="mode-icons"
        style={{
          marginBottom: hoverState.truck || hoverState.rail ? "8px" : "5px",
          transition: "margin-bottom 0.2s ease-in-out",
        }}
      >
        {availableModes.includes("TRUCK") && (
          <Button
            id="truck-mode-button"
            className={`${
              modeData.truck.visible ? "active-truck" : ""
            } truck-mode-button`}
            sx={{
              px: 1,
              minWidth: "auto",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.15)",
              },
            }}
            onClick={() => handleModeToggle("truck")}
            onMouseEnter={() =>
              setHoverState((prev) => ({ ...prev, truck: true }))
            }
            onMouseLeave={() =>
              setHoverState((prev) => ({ ...prev, truck: false }))
            }
          >
            <TruckIconFO
              color={
                modeData.truck.visible || hoverState.truck
                  ? "#38BDF8"
                  : "#9CA3AF"
              }
            />
          </Button>
        )}
        {availableModes.includes("RAIL") && (
          <Button
            id="rail-mode-button"
            className={`${
              modeData.rail.visible ? "active-rail" : ""
            } rail-mode-button`}
            sx={{
              px: 1,
              minWidth: "auto",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                transform: "scale(1.15)",
              },
            }}
            onClick={() => handleModeToggle("rail")}
            onMouseEnter={() =>
              setHoverState((prev) => ({ ...prev, rail: true }))
            }
            onMouseLeave={() =>
              setHoverState((prev) => ({ ...prev, rail: false }))
            }
          >
            <RailIconFO
              color={
                modeData.rail.visible || hoverState.rail ? "#F97316" : "#9CA3AF"
              }
            />
          </Button>
        )}
      </div>
      <div className="price-list">
        {modeData.truck.visible && availableModes.includes("TRUCK") && (
          <PriceInputRow
            icon={<TruckIconFO color="#64748B" />}
            altValue={modeData.truck.minValue}
            fobValue={modeData.truck.maxValue}
            onFobChange={(value: string) => {
              handleFobChange("truck", value);
            }}
            onAltChange={(value: string) => {
              handleAltChange("truck", value);
            }}
            hasUpdate={false}
          />
        )}
        {modeData.rail.visible && availableModes.includes("RAIL") && (
          <PriceInputRow
            icon={<RailIconFO color="#64748B" />}
            altValue={modeData.rail.minValue}
            fobValue={modeData.rail.maxValue}
            onFobChange={(value: string) => {
              handleFobChange("rail", value);
            }}
            onAltChange={(value: string) => {
              handleAltChange("rail", value);
            }}
            hasUpdate={false}
          />
        )}
      </div>
    </div>
  );
};

export default OriginColumn;
